const formatPercent = (decimal) => {
  if (decimal === 0 || decimal) {
    return decimal.toLocaleString(undefined, { style: 'percent' });
  }
  return false;
};

export default formatPercent;
